import React, { useState } from 'react'
import '../css/Console.css'

import { useParams, useNavigate } from 'react-router-dom'

import { ShareAltOutlined, SettingOutlined, PieChartOutlined, PayCircleOutlined, UserOutlined, AppstoreOutlined, UserSwitchOutlined, BarcodeOutlined, BuildOutlined, CloudSyncOutlined } from '@ant-design/icons'
import { Layout, Menu, Alert, Result } from 'antd'

import Home from './app/Home'
import Member from './app/Member'
import Aan from './app/Aan'
import Over from './app/Over'
// import Chg from './app/Chg'
import ChgV2 from './app/ChgV2'
// import Kcard from './app/Kcard'
// import Kbot from './app/Kbot'
// import Aws from './app/Aws'
import AwsV2 from './app/AwsV2'
import Nzcos from './app/Nzcos'
import Product from './app/Product'
// import AwsConfig from './app/AwsConfig'
// import Workorder from './app/Workorder'
import Order from './app/Order'
// import OrderAdmin from './app/OrderAdmin'
import Wlist from './app/Wlist'
import Flist from './app/Flist'
import Vihg from './app/Vihg'
import Set from './app/Set'
import YunCg from './app/YunCg'

const { Sider } = Layout

//  控制台布局
function Console(props) {
    const id = useParams().id
    const navigate = useNavigate()
    const [data, setData] = useState(id)
    const [items, setItems] = useState([
        getItem('总览', 'home', <PieChartOutlined />),
        getItem('开放平台', 'open', <ShareAltOutlined />, [
            // getItem('代码托管', 'chg'),
            getItem('资源托管系统', 'chgv2', null, null, null, 'admin'),
            // getItem('一键汉化', 'csn'),
            // getItem('一键去墙', 'aws'),
            // getItem('一键去墙 V2', 'awsv2', null, null, null, 'admin'),
            // getItem('一键去墙 [配置]', 'awsconfig', null, null, null, 'admin'),
            getItem('NZ云存储 V2', 'nzcos'),
            getItem('图片托管', 'vihg', null, null, null, 'admin'),
            // getItem('[KOOK] 卡片托管', 'kcard'),
            // getItem('[KOOK] Bot管理', 'kbot'),
        ], null),
        getItem('会员中心', 'member', <UserOutlined />),
        getItem('产品中心', 'product', <BuildOutlined />),
        getItem('订单中心', 'order', <BarcodeOutlined />),
        // getItem('订单中心 [管理]', 'orderadmin', <BarcodeOutlined />, null, null, 'article_release'),
        getItem('余额中心', 'over', <PayCircleOutlined />),
        getItem('资产授权', 'aan', <AppstoreOutlined />),
        getItem('云配置', 'yuncg', <CloudSyncOutlined />, null, null, null, 'admin'),
        getItem('关注/粉丝', 'wf', <UserSwitchOutlined />, [
            getItem('已关注列表', 'wlist'),
            getItem('粉丝列表', 'flist'),
        ]),
        getItem('设置', 'set', <SettingOutlined />),
        // getItem('工单系统', 'workorder', <BranchesOutlined />, null, null, 'admin'),
    ])
    const [width] = useState(window.innerWidth)


    //  监听选项回调
    function MenuClick(item) {
        navigate('/app/' + item.key)
        setData(item.key)
    }

    //  处理子页面
    function Content() {
        if (!props.state.token) {
            // navigate('/login')
            return (
                <Result
                    status="403"
                    title="403"
                    subTitle="请登录再访问页面"
                />
            )
        }

        if (props.state.user.suser) {
            return (
                <Result
                    status="403"
                    title="403"
                    subTitle="你没有这权限访问"
                />
            )
        }

        if (id === 'home') {
            return (
                <Home {...props} />
            )
        }
        if (id === 'member') {
            return (
                <Member {...props} />
            )
        }
        if (id === 'aan') {
            return (
                <Aan {...props} />
            )
        }
        if (id === 'over') {
            return (
                <Over {...props} />
            )
        }
        if (id === 'order') {
            return (
                <Order {...props} />
            )
        }
        if (id === 'yuncg') {
            return (
                <YunCg {...props} />
            )
        }


        // if (id === 'orderadmin') {
        //     return (
        //         <OrderAdmin {...props} />
        //     )
        // }
        // if (id === 'chg') {
        //     return (
        //         <Chg {...props} />
        //     )
        // }
        if (id === 'chgv2') {
            return (
                <ChgV2 {...props} />
            )
        }

        // if (id === 'kcard') {
        //     return (
        //         <Kcard {...props} />
        //     )
        // }
        // if (id === 'kbot') {
        //     return (
        //         <Kbot {...props} />
        //     )
        // }
        // if (id === 'aws') {
        //     return (
        //         <Aws {...props} />
        //     )
        // }
        // if (id === 'awsv2') {
        //     return (
        //         <AwsV2 {...props} />
        //     )
        // }


        if (id === 'nzcos') {
            return (
                <Nzcos {...props} />
            )
        }
        if (id === 'product') {
            return (
                <Product {...props} />
            )
        }


        // if (id === 'awsconfig') {
        //     return (
        //         <AwsConfig {...props} />
        //     )
        // }
        // if (id === 'workorder') {
        //     return (
        //         <Workorder {...props} />
        //     )
        // }
        if (id === 'wlist') {
            return (
                <Wlist {...props} />
            )
        }
        if (id === 'flist') {
            return (
                <Flist {...props} />
            )
        }
        if (id === 'set') {
            return (
                <Set {...props} />
            )
        }
        if (id === 'vihg') {
            return (
                <Vihg {...props} />
            )
        }
        return (
            <Result
                status="404"
                title="404"
                subTitle="您访问的页面已经跑路了"
            />
        )
    }

    function getItem(label, key, icon, children, type, ay) {
        if (ay) {
            if (props.verifyAy(ay)) {
                return {
                    key,
                    icon,
                    children,
                    label,
                    type,
                }
            }
        } else {
            return {
                key,
                icon,
                children,
                label,
                type,
            }
        }
    }

    const MemoizedContent = React.memo(Content)

    if (props.state.token) {
        return (
            <div className='console'>
                <Layout>
                    <Layout>
                        <Sider
                            width={200}
                        >
                            <Menu
                                mode="vertical"
                                selectedKeys={[data]}
                                style={{
                                    height: '100%',
                                    borderRight: 0,
                                }}
                                items={items}
                                onSelect={MenuClick}
                            />
                        </Sider>
                        <Layout
                            style={{
                                padding: '0 24px 24px',
                                backgroundColor: '#141414',
                                width: (Math.floor(width * 0.6) - 200)
                            }}
                        >
                            {/* <Alert message="欢迎使用基于N2YUN网站开发的可视化控制台" type="info" /> */}
                            <div className='appContent'>
                                <MemoizedContent {...props} />
                            </div>
                        </Layout>
                    </Layout>
                </Layout>
            </div>
        )
    } else {
        // navigate('/login')
        return (
            <Result
                status="403"
                title="403"
                subTitle="请登录再访问页面"
            />
        )
    }
}

export default Console;